import { ComponentStyleConfig } from '@chakra-ui/react';

const PopoverStyles: ComponentStyleConfig = {
  baseStyle: {
    _focusVisible: {
      outline: 'none !important',
      boxShadow: 'none !important',
      outlineOffset: '0 !important',
    },
  },
};

export default PopoverStyles;
